const ServiceTypes = Object.freeze({
  Evaluation: 1,
  Therapy: 2,
  Equipment: 3,
  Assistant: 4,
  Transportation: 5,
  Barriers: 6,
  UnAvailable: 7,
  Nurse: 8,
});

export const ServiceTypeComponentObj = {
  Assistant: {
    serviceId: ServiceTypes.Assistant,
    icon: 'fal fa-users',
    label: 'Asistente, Enfermero(a) y/o Interprete',
    component: 'Assistant',
    permissionName: 'menu.rempro.view.assistantservice',
  },
  Barriers: {
    serviceId: ServiceTypes.Barriers,
    icon: 'fal fa-user-shield',
    label: 'Barreras',
    component: 'Barrier',
    permissionName: 'menu.rempro.view.barrierservice',
  },
  Equipment: {
    serviceId: ServiceTypes.Equipment,
    icon: 'fal fa-books',
    label: 'Equipo',
    component: 'Equipment',
    permissionName: 'menu.rempro.view.equipmentservice',
  },
  Evaluation: {
    serviceId: ServiceTypes.Evaluation,
    icon: 'fal fa-clipboard-list-check',
    label: 'Evaluación',
    component: 'Evaluation',
    permissionName: 'menu.rempro.view.evaluationservice',
  },
  Therapy: {
    serviceId: ServiceTypes.Therapy,
    icon: 'fal fa-user-clock',
    label: 'Terapia',
    component: 'Therapy',
    permissionName: 'menu.rempro.view.therapyservice',
  },
  Transportation: {
    serviceId: ServiceTypes.Transportation,
    icon: 'fal fa-bus',
    label: 'Transportación',
    component: 'Transportation',
    permissionName: 'menu.rempro.view.transportationservice',
  },
  UnAvailable: {
    serviceId: ServiceTypes.UnAvailable,
    icon: 'fal fa-clock',
    label: 'No Disponible',
    component: 'UnAvailable',
    permissionName: 'menu.rempro.view.unavailableservice',
  },
};

export default ServiceTypes;
